<template>
  <PatientProfileModalSkeleton v-if="!patientData.isLoaded" />
  <div v-else>
    <div class="text--text pa-4">
      <div class="text-subtitle-1 mb-6">
        {{ $i18next.t('Доверие к профилю', options) }}
      </div>
      <PatientProfileTrustInfo
        :trust-percent="patientData.trust_percent"
        :can-trust="patientData.can_trust"
        class="mb-6"
      />
      <PatientProfileCriteria
        class="mb-10"
        :criteria="patientData.trust_criteria"
      />
      <PatinetProfileRatesStatistic
        class="mb-10"
        :count-canceled="patientData.count_rates_canceled"
        :count-negative="patientData.count_rates_negative"
        :count-positive="patientData.count_rates_positive"
        :count-without-mark="patientData.count_rates_without_mark"
      />

      <div class="d-flex justify-space-between text-subtitle-1 mb-6">
        <span class="mr-4">
          {{ $i18next.t('Записи на приём через', options) }} <br> {{ isYDoc ? 'YDoc' : 'Продокторов' }}
        </span>
        <span data-qa="patient_profile_count_appointments">
          {{ patientData.count_appointments || $i18next.t('Нет', options) }}
        </span>
      </div>
    </div>
    <div
      :class="[
        'b-btn-fixed b-btn-fixed_active patient-profile-modal__fixed-container',
        { 'pa-2': btnFixedFloat },
      ]"
    >
      <button
        :data-qa="dataQALocators.node_btn_close"
        :class="[
          'b-btn-fixed__control b-button b-button_blue patient-profile-modal__fixed-btn',
          { 'patient-profile-modal__fixed-btn_float': btnFixedFloat },
        ]"
        @click="handleCloseModal"
      >
        <span class="text-button">
          {{ $i18next.t('Закрыть', options) }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import PatientProfileModalSkeleton from 'www/vue_components/common/PatientProfile/components/common/PatientProfileModalSkeleton.vue'
import { PATIENT_PROFILE_QA_GOALS } from 'www/dataQA'
import PatientProfileCriteria from 'www/vue_components/common/PatientProfile/components/common/PatientProfileCriteria.vue'
import PatinetProfileRatesStatistic from 'www/vue_components/common/PatientProfile/components/common/PatinetProfileRatesStatistic.vue'
import PatientProfileTrustInfo from 'www/vue_components/common/PatientProfile/components/common/PatientProfileTrustInfo.vue'
import getUserLanguage from 'src/utils/getUserLanguage'

export default {
  name: 'PatientProfileModalContent',
  components: {
    PatientProfileTrustInfo,
    PatinetProfileRatesStatistic,
    PatientProfileCriteria,
    PatientProfileModalSkeleton,
  },
  props: {
    patientData: {
      type: Object,
      default: () => ({}),
    },
    btnFixedFloat: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dataQALocators: {
      ...PATIENT_PROFILE_QA_GOALS,
    },
    isYDoc: window.IS_YDOC,
    options: { ns: getUserLanguage() },
  }),
  methods: {
    handleCloseModal() {
      this.$emit('modal:close')
    },
  },
}
</script>

<style lang="scss">
.patient-profile-modal {
  &__progress-circular .v-progress-circular__overlay {
    stroke-linecap: round;
  }
}
</style>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.patient-profile-modal {
  &__fixed-container {
    position: absolute;
  }

  &__fixed-btn {
    &_float {
      width: 144px;
      margin-left: auto;
    }
  }
}
</style>
